import {Component} from '@angular/core';
import {FormGroup} from '@angular/forms';

@Component({
  selector: 'app-form-button',
  templateUrl: './form-button.component.html'
})
export class FormButtonComponent {
  config;
  grupo: FormGroup;
  clicked;

  emitClick() {
    this.clicked.emit(this.grupo);
  }
}
